<div>
    <form [formGroup]="baseFormGroup" #f="ngForm" class="">
        <!-- brfak, datfak, datdpo, iznos -->
        <div class="row">
            <div class="col-md-4 col-12">
                <div class="form-group row">
                    <div class="col-md-12">
                        <yt-input 
                            [Type]="'text'" 
                            [Label]="'KOZDOKUMENTSTAVKA.BRFAK.SINGULAR'" 
                            formControlName="Brfak">
                        </yt-input>
                    </div>
                    <div class="form-error" *ngIf="submitted && fc.Brfak.invalid">
                        <span *ngFor="let validation of errorMessages.Brfak">
                            <span class="error-message" *ngIf="fc.Brfak.hasError(validation.type)">
                                <span translate="{{validation.message}}"></span>
                            </span>
                        </span>
                    </div>
                </div>
            </div>
            <div class="col-md-2 col-12">
                <div class="form-group row">
                    <div class="col-md-12 col-6">
                        <yt-fw-date-picker-popup 
                            formControlName="Datfak" 
                            name="txtDatfak" 
                            [Label]="'KOZDOKUMENTSTAVKA.DATFAK.SINGULAR'">
                        </yt-fw-date-picker-popup>
                    </div>
                    <div class="form-error" *ngIf="submitted && fc.Datfak.invalid">
                        <span *ngFor="let validation of errorMessages.Datfak">
                            <span class="error-message" *ngIf="fc.Datfak.hasError(validation.type)">
                                <span translate="{{validation.message}}"></span>
                            </span>
                        </span>
                    </div>
                </div>
            </div>
            <div class="col-md-2 col-12">
                <div class="form-group row">
                    <div class="col-md-12 col-6">
                        <yt-fw-date-picker-popup 
                            formControlName="Datdpo" 
                            name="txtDatdpo" 
                            [Label]="'KOZDOKUMENTSTAVKA.DATDPO.SINGULAR'">
                        </yt-fw-date-picker-popup>
                    </div>
                    <div class="form-error" *ngIf="submitted && fc.Datdpo.invalid">
                        <span *ngFor="let validation of errorMessages.Datdpo">
                            <span class="error-message" *ngIf="fc.Datdpo.hasError(validation.type)">
                                <span translate="{{validation.message}}"></span>
                            </span>
                        </span>
                    </div>
                </div>
            </div>

            <div class="col-md-2 col-6">
                <div class="form-group row">
                    <div class="col-md-12">
                        <yt-number-input-v3 
                            name="txtIznos" 
                            formControlName="Iznos" 
                            [Label]="'KOZDOKUMENTSTAVKA.IZNOS.SINGULAR'">
                        </yt-number-input-v3>
                    </div>
                    <div class="form-error" *ngIf="submitted && fc.Iznos.invalid">
                        <span *ngFor="let validation of errorMessages.Iznos">
                            <span class="error-message" *ngIf="fc.Iznos.hasError(validation.type)">
                                <span translate="{{validation.message}}"></span>
                            </span>
                        </span>
                    </div>
                </div>
            </div>
        </div>
        <!-- Kraj brfak, datfak, datpdo, iznos -->


        <!-- Organizaciona jedinica -->
        <!-- <div class="row">
        <div class="col-md-12 col-12">
            <div class="form-group row">
                <div class="col-md-12">
                        <yt-dropdown-picklist
                        [ModelName]="'orgjed'"
                        [GetName]="'get'"
                        [ModelProperty]="'Naziv'"
                        [OrderBy]="'Naziv'"
                        [AllowAddNew]="true"
                        formControlName="OrgJedID"
                        [Label]="'KOZDOKUMENTSTAVKA.ORGJED.SINGULAR'"
                        >
                      </yt-dropdown-picklist>
                </div>        
            </div>
        </div>
    </div> -->
        <!-- Kraj Organizaciona jedinica -->
    </form>
</div>